import React from "react";
import T from "prop-types";
import { reduxForm, Field } from "redux-form";
import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import { Button } from "react-bootstrap";
import { Icon } from "MODULES/shared/components";
import { Body, Footer } from "MODULES/shared/components/Modal";
import { FormInput, TextArea } from "MODULES/shared/components/Forms";
import api from "APP_ROOT/api";
import { toastr } from "react-redux-toastr";
import { ID } from "APP_ROOT/constants";
import { useDispatch } from "APP_ROOT/hooks";
import * as actionTypes from "MODULES/inventories/actionTypes";

const FORM_NAME = "request-scrap-at-shop";

function Form({ close, handleSubmit, invalid, submitting }) {
  return (
    <form onSubmit={handleSubmit}>
      <Body>
        <Field component={FormInput} name="to" label="To:" required />
        <Field component={FormInput} name="cc" label="CC:" />
        <Field component={FormInput} name="bcc" label="BCC:" />
        <Field component={FormInput} name="subject" label="Subject" required />
        <Field component={TextArea} name="body" label="Body" required />
      </Body>
      <Footer>
        <Button
          onClick={() => {
            close();
          }}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          bsStyle="primary"
          disabled={invalid || submitting}
        >
          <Icon name="envelope" fixed />
          &nbsp;Yes, Send Email
        </Button>
      </Footer>
    </form>
  );
}

Form.propTypes = {
  close: T.func.isRequired,
  handleSubmit: T.func.isRequired,
  invalid: T.bool.isRequired,
  submitting: T.bool.isRequired
};

export default reduxForm({
  form: FORM_NAME,
  validate: values =>
    validator(values, form => {
      form.validate("subject", "body", "to").satisfies(rules.required);
      form.validate("to", "cc").satisfies(rules.isValidEmail);
    }),
  onSubmit: async (params, _, props) => {
    await api.inventories
      .requestScrapAtShop(props.inventory.get(ID), params)
      .then(({ data }) => {
        const dispatch = useDispatch();
        dispatch({ type: actionTypes.SET, inventory: data });
        props.close();
        toastr.success("Success", "Email successfully sent.");
      })
      .catch(() =>
        toastr.error(
          "Error",
          "Could not send email. Please refresh page and try again."
        )
      );
  }
})(Form);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/RequestScrapAtShop/Form.jsx